import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { HostListener } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Params, Router} from '@angular/router';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.sass']
})
export class HeaderComponent {
  @Output() changeLanguage = new EventEmitter<string>();
	public id:string = 'navbar-header';
  currentLanguage: string = 'en'; // default is 'es'
  currentSection: string = 'home';

  constructor(public translate: TranslateService, private activatedRoute: ActivatedRoute) {
  }
  changeLang (lang: string) {
    this.translate.use(lang);
    //console.log("Changed language to ", lang)
    this.currentLanguage = lang;
  }
  ngOnInit () {
    // xapuces per canviaridioma...
    if(document.URL.includes("lang=es")) {
      this.changeLang('es');
      //console.log("Inclou peticio ES------");
    } else {
      this.changeLang('en');
      //console.log("No ES");
    }
  }

  onClickMenu( selection = 'home') {
    //console.log('Ruta seleccionada abans: ', this.currentSection);
    // console.log('this.id', this.id);
  	(<any>window).jQuery(`#${this.id}`).collapse('hide');
    this.currentSection = selection;
    //console.log('Ruta seleccionada despres: ', this.currentSection);

    let el = document.getElementById(this.currentSection);
    // console.log(el);
      if(el) {
        el.scrollIntoView();
      }

  }
  @HostListener('window:scroll', ['$event']) // for window scroll events
    onScroll(event) {
      var element =  document.getElementById('services');
      if (typeof(element) != 'undefined' && element != null)
      {
        let pos = (document.documentElement.scrollTop);
        var services = document.getElementById('services').offsetTop;
        var works = document.getElementById('works').offsetTop;
        var curriculum = document.getElementById('curriculum').offsetTop;
        var contact = document.getElementById('contact').offsetTop;
        var limit = document.body.scrollHeight-window.innerHeight;

        if (pos < services) {
          this.currentSection = 'home'
        }
        if (pos > services) {
          this.currentSection = 'services'
        }
        if (pos > works) {
          this.currentSection = 'works'
        }
        if (pos > curriculum) {
          this.currentSection = 'curriculum'
        }
        if (pos > limit) {
          this.currentSection = 'contact'
        }
      }
      //console.log(pos);
      //console.log(limit);
      //console.log(section);

    }
}



// WEBPACK FOOTER //
// ./src/app/header/header.component.ts